import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { TServiceClientActionTypes } from '../types';
import { CREATE_SERVICE_CLIENT } from '../constants/actions';
import { IServiceClient } from 'src/interfaces/serviceClient';

export const createServiceClient = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    body: Record<string, unknown>
): Promise<Partial<IServiceClient> | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post('/service-clients/create', body, HEADERS({
            isReadPermissionNecessary: false,
        }));
        dispatch({
            type: CREATE_SERVICE_CLIENT,
            payload: res.data.data,
        });
        return res.data.data;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
